import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';
import { form_ctrl } from 'ww2_analytics/segments/missions_form';
import { form_template } from '../form';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory('runner_battler_api', function(service_api, $scope, model) {
        $scope.rows = [];
        service_api.retention_by_mission_table(model).then(rows => $scope.rows = rows);
    }),
};
const state_config = {
    url: '/retention_by_mission',
    reloadOnSearch: false,
    data: {
        priority: 900,
        title: 'Retention By Mission',
    },
    views: {
        '': main_view,
        'main-filter@amt.ww2': {
            template: form_template,
            controller: form_ctrl,
        },
    },
};
export default state_config;
